import { animate, state, style, transition, trigger } from '@angular/animations'
import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectorRef, HostListener, ViewChild } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { combineLatest, Observable, of, Subject } from 'rxjs'
import * as fromClaimStore from '@app/claims/store'
import * as fromTripStore from '@app/trips/store'
import * as fromShopStore from '@app/shop/store'
import * as fromCoreStore from '@app/core/store'
import * as fromSharedStoreAction from '@app/shared/store/actions'
import * as fromUserStore from '@app/users/store'
// import * as fromOrderStore from '@app/quotes/store'

import * as fromModalStoreActions from '@app/core/store/actions'
import * as fromModalStoreSelectors from '@app/core/store/selectors'

import { Location } from '@angular/common'
import { NavigationStart, Router } from '@angular/router'
import { GetNewVersionNotification } from '@app/core/store'
import { User } from '@app/shared/models'
import { DieselService, RedirectService, ScheduleService, Theme, ThemeService } from '@app/shared/services'
import { Store } from '@ngrx/store'
import { Actions, ofType } from '@ngrx/effects'
import { catchError, debounceTime, distinctUntilChanged, filter, map, take, takeUntil, tap } from 'rxjs/operators'
import { PushNotifications } from '../services/push-notifications.service'
import { NgxPopperjsTriggers, NgxPopperjsPlacements, NgxPopperjsContentComponent } from 'ngx-popperjs'
import { environment } from 'environments/environment'
import { HttpClient } from '@angular/common/http'
declare var require: any

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NavigationComponent implements OnInit, OnDestroy {

  NgxPopperjsTriggers = NgxPopperjsTriggers
  NgxPopperjsPlacements = NgxPopperjsPlacements
  @ViewChild('logUsersNav', { static: false }) logUsersNav: NgxPopperjsContentComponent

  menuState = 'in'
  @Output()
  onActiveMenu = new EventEmitter<boolean>()
  @Output()
  onNavMobileClose = new EventEmitter<void>()

  @Input()
  options: { isActiveSidebar?: boolean, mobile?: boolean } = { isActiveSidebar: false, mobile: false }

  theme: Theme = 'light'

  openNavigation = false
  openAccountsMobile = true
  currentUser$: Observable<User>
  userSettings$: Observable<any>
  loggedIn$: Observable<boolean>
  destroyed$ = new Subject<boolean>()
  isLoadedAccounts$: Observable<boolean>
  statusSidebar = false
  @Input()
  isSubscribed = false
  onCustomerPortal = false
  widthOutput = null;
  locationEvent$
  contact
  roles = {}
  currentRoute: string
  schedulesCount = 0
  appVersion = require('../../../../package.json').version
  isLoggedIn = false
  user = null
  fullView: boolean = false
  allDispatcher = false

  constructor(
    public dieselService: DieselService,
    private _sanitizer: DomSanitizer,
    private _PushNotifications: PushNotifications,
    private store: Store,
    private router: Router,
    private location: Location,
    private http: HttpClient,
    private redirectService: RedirectService,
    private themeService: ThemeService,
    private cdr: ChangeDetectorRef,
    private actions$: Actions
  ) {
    this.router.events.subscribe(
      eventItem => {
        if (eventItem instanceof NavigationStart) {
          this.currentRoute = this.location.path()
          const currentRouteItems = this.currentRoute.split('/').filter(t => !!t).map(item => {
            return item?.indexOf('?') !== -1 ? item?.substring(0, item?.indexOf('?')) : item
          })
          const eventItemItems = eventItem.url.split('/').filter(t => !!t).map(item => {
            return item?.indexOf('?') !== -1 ? item?.substring(0, item?.indexOf('?')) : item
          })
          if (eventItemItems?.length > 1 && currentRouteItems?.length > 1 && eventItemItems?.[1] !== currentRouteItems?.[1]) {
            // Don't remove store if its navigate inside order from quote to loadboard or vice versa
            if ((eventItemItems?.[1] === 'loadboard' || currentRouteItems?.[1] === 'quotes') || (eventItemItems?.[1] === 'quotes' || currentRouteItems?.[1] === 'loadboard') && currentRouteItems?.[2]) {
              return
            }
            this.store.dispatch(new fromSharedStoreAction.CleanStore())
          }
        }
      }
    )
  }
  getRoles = false;
  userIndex = 0
  sessions = []
  scheduleFilters = null
  lastTokenCheck = 0

  ngOnInit() {
    this.userIndex = this.redirectService.getUrlIndex()
    this.themeService.theme$.pipe(takeUntil(this.destroyed$)).subscribe(theme => {
      this.theme = theme
      this.cdr.markForCheck()
    })
    this.store.select(fromCoreStore.selectPetPendingCount).pipe(
      takeUntil(this.destroyed$),
      map(count => {
        this.schedulesCount = count
        this.cdr.detectChanges()
      })
    ).subscribe()

    combineLatest([
      this.store.select(fromCoreStore.selectScheduleFilter),
      this.store.select(fromUserStore.getLoggedIn),
      this.store.select(fromUserStore.getUser)
    ])
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe(([filters, loggedIn, user]) => {

        this.allDispatcher = !!filters?.allDispatcher || false

        this.isLoggedIn = loggedIn
        let f = {
          ...filters,
        }

        if (f?.rangeType) delete f.rangeType
        if (f?.driver) {
          f['driverId'] = f.driver._id
          delete f.driver
        }
        if (f?.unit) {
          f['unitId'] = f.unit._id
          delete f.unit
        }
        if (f?.dispatcher) {
          f['dispatchId'] = f.dispatcher._id
          delete f.dispatcher
        }
        if (user?.type == 'DISPATCH' && !this.allDispatcher) {
          f['dispatchId'] = user._id
        }
        delete f?.allDispatcher
        delete f?.onlySetStorage

        if (JSON.stringify(this.scheduleFilters) !== JSON.stringify(f)) {
          this.scheduleFilters = f
          if (loggedIn) {
            this.store.dispatch(new fromCoreStore.GetTabs(f))
          }
        }
      })

    this.currentUser$ = this.store.select(fromUserStore.getUser)
    this.userSettings$ = this.store.select(fromUserStore.getUserSettings)
    this.isLoadedAccounts$ = this.store.select(fromCoreStore.getContactLoaded)
    this.isLoadedAccounts$
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe()
    this.store.dispatch(new GetNewVersionNotification({ version: this.appVersion }))

    this.store.select(fromModalStoreSelectors.selectPermissionRoleEntities).pipe(
      takeUntil(this.destroyed$),
      map(r => {
        this.roles = r

        if (this.isLoggedIn) {
          !Object.keys(r)?.length && this.store.dispatch(new fromModalStoreActions.GetPermissionRoles())
        }
        this.cdr.detectChanges()
      })
    ).subscribe()

    this.store
      .select(fromUserStore.getUser)
      .pipe(
        takeUntil(this.destroyed$),
        tap(user => {
          if (user) {
            this.user = user
            this.sessions = this.redirectService.getSessions().filter(s => s.userId !== user._id)
            this.userIndex = this.redirectService.getUrlIndex()
          }
        }),
        debounceTime(500),
        filter(() =>
          !Object.keys(this.roles)?.length
          && this.isLoggedIn
        ),
        take(1),
        tap(() => {
          this.store.dispatch(new fromModalStoreActions.GetPermissionRoles())
        }),
      )
      .subscribe()

    window.addEventListener("resize", this.resizeListener)
    window.addEventListener("storage", (event) => {
      if (event?.key?.includes('session/') && ((event?.newValue === null && event?.oldValue !== null) || (event?.newValue !== null && event?.oldValue === null))) {
        if (this.user?._id) {
          this.sessions = this.redirectService.getSessions().filter(s => s.userId !== this.user._id)
          this.cdr.detectChanges()
        }
      }
    }, false)
  }

  resizeDropdown() {
    this.resizeListener()
  }

  navToggle() {
    if (this.logUsersNav) {
      this.logUsersNav.hide()
    }
    this.openNavigation = !this.openNavigation
  }

  checkSessionTokens() {
    const now = Date.now()
    if (this.lastTokenCheck && (now - this.lastTokenCheck) < 5000) {
      return
    }
    this.lastTokenCheck = now

    this.sessions = this.redirectService.getSessions().filter(s => s.userId !== this.user?._id)
    if (!this.sessions?.length) {
      return
    }

    const tokens = this.sessions
      .map(obj => ({
        token: obj?.token,
        userIndex: obj?.userIndex,
        companyName: obj?.companyName,
        userId: obj?.userId
      }))
      .filter(t => t?.token?.length)
    if (!tokens?.length) {
      return
    }
    this.store.dispatch(new fromUserStore.CheckTokens({ tokens }))

    this.actions$.pipe(
      ofType(fromUserStore.AuthActionTypes.CheckTokensSuccess),
      take(1)
    ).subscribe((action: any) => {
      let sessions = this.redirectService.getSessions()
      let resTokens = action.payload.tokens
      for (let obj of resTokens) {
        if (!obj?.active) {
          const key = `session/${obj?.userIndex}`
          let findUser = sessions.find(n => n?.userId == obj?.userId)
          delete findUser?.token
          let storageValue = {
            ...findUser
          }

          localStorage.setItem(key, JSON.stringify(storageValue))
        }
      }
      this.redirectService.clearEmptySessions()
      this.sessions = this.redirectService.getSessions().filter(s => s.userId !== this.user?._id)
      this.cdr.detectChanges()
    })
  }

  onCloseNavigation(page?) {
    if (page == 'schedules') {
      this.store.dispatch(new fromCoreStore.GetTabs(this.scheduleFilters))
    }
    this.openNavigation = false
    this.onNavMobileClose.emit()
  }

  getAbbreviation(input) {
    if (input?.length) {
      const words = input.split(' ')
      return words
        .map(word => word.charAt(0).toUpperCase())
        .join('')
        .slice(0, 3)
    } else {
      return ''
    }
  }

  getAbbreviationOtherUsers(input) {
    if (input?.length) {
      const words = input.split(' ')
      return words
        .map(word => word.charAt(0))
        .join('')
        .slice(0, 3)
    } else {
      return ''
    }
  }


  toggleTheme() {
    this.themeService.setTheme(this.theme === 'dark' ? 'light' : 'dark')
  }

  resizeListener() {
    this.widthOutput = document.querySelector(".dropdown-menu")
    this.widthOutput = document.querySelector(".dropdown-menu")
    if (this.widthOutput) {
      if (window.innerWidth < 1185) {
        this.widthOutput.style['transform'] = `translateX(${+window.innerWidth - 145}px)`
        this.widthOutput.style['transform'] = `translateX(${+window.innerWidth - 145}px)`
      } else {
        this.widthOutput.style['transform'] = ''
        this.widthOutput.style['transform'] = ''
      }
    }
  }
  autocompleListFormatter = (data: any): SafeHtml => {
    const html = `<span>${data.toponymName}, ${data.adminCode1} </span>`
    return this._sanitizer.bypassSecurityTrustHtml(html)
  }

  async togglePushNotifications() {
    this._PushNotifications.toggleSubscription({ isPushEnabled: this.isSubscribed })
    this.isSubscribed = !this.isSubscribed

    // this.store.dispatch(new fromUserStore.TogglePushNotify());
  }

  toggleMenu() {
    // 1-line if statement that toggles the value:
    this.menuState = this.menuState === 'out' ? 'in' : 'out'
    this.dieselService.menuState = this.menuState
    console.log('TOGGLE MENU')
  }

  logout() {
    window.removeEventListener("resize", this.resizeListener)
    this.widthOutput = null
    let currentUrl = window.location.href
    let userIndex = String(parseInt(currentUrl.match(/\/(\d+)\//)?.[1] || '0', 10) || 0)
    this.store.dispatch(new fromUserStore.Logout(userIndex))
    // setTimeout(() => {
    //   this.store.dispatch(new fromClaimStore.ResetClaimFilter({page: 1}))
    // this.store.dispatch(new fromCoreStore.ClearAll())
    //   this.store.dispatch(new fromCoreStore.ResetCandidatesFilter())
    //   this.store.dispatch(new fromTripStore.ResetTripsFilter())
    //   this.store.dispatch(new fromShopStore.ResetFilter())
    //   this.store.dispatch(new fromCoreStore.ResetSchedulesFilter())
    // }, 500);
  }

  submitAuto(jwtToken: string) {

    let currentItem = null

    function getSessionObjects(jwtToken) {
      const sessionValues = []
      for (let i = 0; i < window.localStorage.length; i++) {
        const key = window.localStorage.key(i)
        if (key.startsWith('session/')) {
          const value = JSON.parse(window.localStorage.getItem(key))
          sessionValues.push(value)
          if (value?.token === jwtToken) {
            currentItem = { key, value }
          }
        }
      }
      return sessionValues
    }


    let sessions = getSessionObjects(jwtToken)
    const usedIndices = sessions
      .filter(session => session.userIndex || session.userIndex == 0)
      .map(session => session.userIndex)
      .sort((a, b) => a - b)

    function findNextAvailableIndex(usedIndices) {
      usedIndices.sort((a, b) => a - b)
      for (let i = 0; i <= usedIndices.length; i++) {
        if (!usedIndices.includes(i)) {
          return i
        }
      }
    }

    let userIndex = findNextAvailableIndex(usedIndices)
    let storageValue = JSON.stringify({
      ...currentItem?.value,
      active: true,
      userIndex: (currentItem?.value?.userIndex || currentItem?.value?.userIndex == 0) ? currentItem?.value?.userIndex : userIndex
    })
    let key = currentItem?.key
    localStorage.setItem(key, storageValue)
    // console.log(`#/${(currentItem?.value?.userIndex || currentItem?.value?.userIndex == 0) ? currentItem?.value?.userIndex : userIndex}${currentItem?.value?.isLoadboard ? '/loadboard' : '/quotes'}`, '_blank')
    window.open(`#/${(currentItem?.value?.userIndex || currentItem?.value?.userIndex == 0) ? currentItem?.value?.userIndex : userIndex}${currentItem?.value?.isLoadboard ? '/loadboard' : '/quotes'}`, '_blank')

  }

  addAccount() {

    function getSessionObjects() {
      const sessionValues = []
      for (let i = 0; i < window.localStorage.length; i++) {
        const key = window.localStorage.key(i)
        if (key.startsWith('session/')) {
          const value = JSON.parse(window.localStorage.getItem(key))
          sessionValues.push(value)
        }
      }
      return sessionValues
    }

    let sessions = getSessionObjects()
    const usedIndices = sessions
      .filter(session => session.userIndex || session.userIndex == 0)
      .map(session => session.userIndex)
      .sort((a, b) => a - b)

    function findNextAvailableIndex(usedIndices) {
      usedIndices.sort((a, b) => a - b)
      for (let i = 0; i <= usedIndices.length; i++) {
        if (!usedIndices.includes(i)) {
          return i
        }
      }
    }

    let nextUserIndex = findNextAvailableIndex(usedIndices)

    window.open(`#/${nextUserIndex}/login`, '_blank')
  }

  post(jwtToken: string): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}/admin/loginViaAccessToken`, {
        pushToken: "null",
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: true
      })
      .pipe(
        catchError(error => {
          console.error('Request error:', error)
          throw error
        })
      )
  }

  ngOnDestroy() {
    this.destroyed$.next(true)
    this.destroyed$.complete()
  }
}
